export const formsEn: Record<string, string> = {
  'forms': 'Forms',
  'forms.title': 'Forms',
  'forms.subtitle': 'Create and manage embeddable forms for your website',
  'forms.newForm': 'New Form',
  'forms.createForm': 'Create Form',
  'forms.noFormsTitle': 'No forms yet',
  'forms.noFormsDesc': 'Create your first form to start collecting leads from your website',
  'forms.version': 'Version',
  'forms.submissions': 'Submissions',
  'forms.language': 'Language',
  'forms.edit': 'Edit',
  'forms.duplicate': 'Duplicate',
  'forms.duplicateSuccess': 'Form duplicated successfully',
  'forms.duplicateError': 'Failed to duplicate form',
  'forms.status.draft': 'Draft',
  'forms.status.published': 'Published',
  'forms.status.archived': 'Archived',
  'forms.builder.save': 'Save',
  'forms.builder.saving': 'Saving...',
  'forms.builder.publish': 'Publish',
  'forms.builder.publishing': 'Publishing...',
  'forms.builder.unpublish': 'Unpublish',
  'forms.builder.unpublishing': 'Unpublishing...',
  'forms.builder.tab_builder': 'Builder',
  'forms.builder.tab_display': 'Display',
  'forms.builder.tab_settings': 'Settings',
  'forms.builder.tab_preview': 'Preview',
  'forms.builder.version_created': 'New draft version created (v{version})',
  'forms.builder.saved': 'Form saved (v{version})',
  'forms.builder.published_success': 'Form published successfully',
  'forms.builder.unpublished_success': 'Form unpublished successfully',
  'forms.builder.save_failed': 'Failed to save form',
  'forms.builder.publish_failed': 'Failed to publish form',
  'forms.builder.unpublish_failed': 'Failed to unpublish form',
  'forms.builder.load_failed': 'Failed to load form data',
  'forms.builder.advanced.templates.title': 'Form Templates',
  'forms.builder.advanced.templates.description': 'Choose from pre-built templates to quickly set up your form structure',
  'forms.builder.advanced.templates.applied': 'Applied "{name}" template',
  'forms.mappingTemplates.title': 'Mapping Templates',
  'forms.mappingTemplates.categoryTemplates': '{category} templates',
  'forms.mappingTemplates.fields': 'fields',
  'forms.mappingTemplates.fieldsIncluded': 'Fields included ({count}):',
  'forms.mappingTemplates.required': 'Required',
  'forms.mappingTemplates.actions.preview': 'Preview',
  'forms.mappingTemplates.actions.applyTemplate': 'Apply Template',
  'forms.mappingTemplates.actions.apply': 'Apply',
  'forms.mappingTemplates.toast.appliedTitle': 'Template Applied',
  'forms.mappingTemplates.toast.appliedDescription': '{templateName} template has been applied with {fieldCount} field mappings.',
  'forms.mappingTemplates.categories.bridal': 'Bridal',
  'forms.mappingTemplates.categories.business': 'Business',
  'forms.mappingTemplates.categories.general': 'General',
  'forms.mappingTemplates.categories.ecommerce': 'Ecommerce',
  'forms.mappingTemplates.template.bridalInquiry.name': 'Bridal Inquiry Form',
  'forms.mappingTemplates.template.bridalInquiry.description': 'Complete bridal consultation form with wedding details and preferences',
  'forms.mappingTemplates.template.businessContact.name': 'Business Contact Form',
  'forms.mappingTemplates.template.businessContact.description': 'Standard business inquiry form for lead generation',
  'forms.mappingTemplates.template.customerRegistration.name': 'Customer Registration',
  'forms.mappingTemplates.template.customerRegistration.description': 'Complete customer profile creation form',
  'forms.mappingTemplates.template.appointmentBooking.name': 'Appointment Booking',
  'forms.mappingTemplates.template.appointmentBooking.description': 'Schedule appointments with customer details',
  'forms.mappingTemplates.template.productInquiry.name': 'Product Inquiry',
  'forms.mappingTemplates.template.productInquiry.description': 'Product interest and specification form',
  'forms.mappingTemplates.labels.brideName': 'Bride Name',
  'forms.mappingTemplates.labels.partnerName': 'Partner Name',
  'forms.mappingTemplates.labels.emailAddress': 'Email Address',
  'forms.mappingTemplates.labels.phoneNumber': 'Phone Number',
  'forms.mappingTemplates.labels.weddingDate': 'Wedding Date',
  'forms.mappingTemplates.labels.ceremonyVenue': 'Ceremony Venue',
  'forms.mappingTemplates.labels.receptionVenue': 'Reception Venue',
  'forms.mappingTemplates.labels.dressSize': 'Dress Size',
  'forms.mappingTemplates.labels.budgetRange': 'Budget Range',
  'forms.mappingTemplates.labels.stylePreferences': 'Style Preferences',
  'forms.mappingTemplates.labels.brandPreferences': 'Brand Preferences',
  'forms.mappingTemplates.labels.inspirationImages': 'Inspiration Images',
  'forms.mappingTemplates.labels.shoppingTimeline': 'Shopping Timeline',
  'forms.mappingTemplates.labels.interestedInAlterations': 'Interested in Alterations',
  'forms.mappingTemplates.labels.shoppingForBridesmaids': 'Shopping for Bridesmaids',
  'forms.mappingTemplates.labels.interestedInAccessories': 'Interested in Accessories',
  'forms.mappingTemplates.labels.specialRequests': 'Special Requests',
  'forms.mappingTemplates.labels.firstName': 'First Name',
  'forms.mappingTemplates.labels.lastName': 'Last Name',
  'forms.mappingTemplates.labels.companyName': 'Company Name',
  'forms.mappingTemplates.labels.jobTitle': 'Job Title',
  'forms.mappingTemplates.labels.industry': 'Industry',
  'forms.mappingTemplates.labels.companySize': 'Company Size',
  'forms.mappingTemplates.labels.inquiryType': 'Inquiry Type',
  'forms.mappingTemplates.labels.projectTimeline': 'Project Timeline',
  'forms.mappingTemplates.labels.message': 'Message',
  'forms.mappingTemplates.labels.address': 'Address',
  'forms.mappingTemplates.labels.city': 'City',
  'forms.mappingTemplates.labels.stateProvince': 'State/Province',
  'forms.mappingTemplates.labels.zipPostalCode': 'ZIP/Postal Code',
  'forms.mappingTemplates.labels.country': 'Country',
  'forms.mappingTemplates.labels.dateOfBirth': 'Date of Birth',
  'forms.mappingTemplates.labels.howDidYouHear': 'How did you hear about us?',
  'forms.mappingTemplates.labels.marketingConsent': 'I agree to receive marketing communications',
  'forms.mappingTemplates.labels.termsAccepted': 'I accept the terms and conditions',
  'forms.mappingTemplates.labels.fullName': 'Full Name',
  'forms.mappingTemplates.labels.preferredDate': 'Preferred Date',
  'forms.mappingTemplates.labels.preferredTime': 'Preferred Time',
  'forms.mappingTemplates.labels.appointmentType': 'Appointment Type',
  'forms.mappingTemplates.labels.servicesOfInterest': 'Services of Interest',
  'forms.mappingTemplates.labels.additionalNotes': 'Additional Notes',
  'forms.mappingTemplates.labels.emergencyContact': 'Emergency Contact',
  'forms.mappingTemplates.labels.specialAccommodations': 'Special Accommodations Needed',
  'forms.mappingTemplates.labels.customerName': 'Customer Name',
  'forms.mappingTemplates.labels.productOfInterest': 'Product of Interest',
  'forms.mappingTemplates.labels.colorPreferences': 'Color Preferences',
  'forms.mappingTemplates.labels.sizeNeeded': 'Size Needed',
  'forms.mappingTemplates.labels.quantity': 'Quantity',
  'forms.mappingTemplates.labels.deliveryTimeline': 'When do you need this?',
  'forms.mappingTemplates.labels.customizationRequired': 'Customization Required',
  'forms.mappingTemplates.labels.detailedSpecifications': 'Detailed Specifications',
  'forms.mappingTemplates.placeholders.projectDetails': 'Tell us about your project...',
  'forms.builder.advanced.mapping.title': 'Field Mapping Analysis',
  'forms.builder.advanced.mapping.description': 'Visual overview of how your form fields map to data entities with conflict detection',
  'forms.builder.advanced.testing.title': 'Form Testing & Validation',
  'forms.builder.advanced.testing.description': 'Test your form with various scenarios and validate field mappings',
  'forms.builder.advanced.backup.title': 'Backup & Version Control',
  'forms.builder.advanced.backup.description': 'Create backups and restore previous versions of your form',
  'forms.builder.advanced.backup.restored': 'Form restored from backup',
  'forms.display.title': 'Display Settings',
  'forms.display.logo_section': 'Logo Display',
  'forms.display.logo_toggle': 'Show Organization Logo',
  'forms.display.logo_help': "Display your organization's logo at the top of the form",
  'forms.display.text_content': 'Form Text Content',
  'forms.display.form_title': 'Form Title',
  'forms.display.form_title_help': 'Title displayed in the form card header',
  'forms.display.header_text': 'Header Text',
  'forms.display.header_text_help': 'Main heading displayed at the top of the form',
  'forms.display.description_text': 'Description Text',
  'forms.display.description_help': 'Subtitle or description shown below the header',
  'forms.display.powered_by_toggle': 'Show "Powered by" Footer',
  'forms.display.powered_by_help': 'Display attribution text at the bottom of the form',
  'forms.display.footer_text': 'Footer Text',
  'forms.display.footer_help': 'Text displayed in the form footer',
  'forms.display.submit_button': 'Submit Button Text',
  'forms.display.submit_help': 'Text displayed on the form submit button',
  'forms.display.placeholder_title_en': 'Contact Form',
  'forms.display.placeholder_header_en': 'Your Organization Name',
  'forms.display.placeholder_description_en': "Fill out the form below and we'll get back to you soon.",
  'forms.display.placeholder_footer_en': 'Powered by Your Organization',
  'forms.display.placeholder_submit_en': 'Submit Form',
  'forms.create.title': 'Create New Form',
  'forms.create.formName': 'Form Name',
  'forms.create.formKey': 'Form Key',
  'forms.create.defaultLanguage': 'Default Language',
  'forms.create.placeholders.name': 'Contact Form',
  'forms.create.placeholders.key': 'contact-form',
  'forms.create.formKeyDesc': 'Used in the embed URL (e.g., yoursite.com/forms/contact-form)',
  'forms.create.formKeyPatternHelp': 'Only lowercase letters, numbers, and hyphens allowed',
  'forms.create.cancel': 'Cancel',
  'forms.create.creating': 'Creating...',
  'forms.create.createForm': 'Create Form',
  'forms.create.success': 'Form created successfully',
  'forms.create.error': 'Failed to create form',
  'forms.embed.title': 'Embed Form',
  'forms.embed.key': 'Key',
  'forms.embed.warning': 'This form is not published yet. Publish the form first to make it available for embedding.',
  'forms.embed.copySuccess': 'Copied {label} to clipboard',
  'forms.embed.copyError': 'Failed to copy to clipboard',
  'forms.embed.publishNote': 'Only published forms can be embedded on websites',
  'forms.embed.close': 'Close',
  'forms.embed.tabs.script': 'Script Embed',
  'forms.embed.tabs.iframe': 'Iframe Embed',
  'forms.embed.tabs.custom': 'Customized',
  'forms.embed.tabs.tracking': 'Tracking',
  'forms.embed.tabs.direct': 'Direct Link',
  'forms.embed.label.scriptEmbed': 'Script embed',
  'forms.embed.label.iframeEmbed': 'Iframe embed',
  'forms.embed.label.customEmbed': 'Customized embed',
  'forms.embed.label.trackingCode': 'Tracking code',
  'forms.embed.script.title': 'Script Embed (Recommended)',
  'forms.embed.script.desc': 'Dynamically loads the form into your page with automatic styling',
  'forms.embed.script.htmlCode': 'HTML Code',
  'forms.embed.script.pros': 'Pros',
  'forms.embed.script.pro1': 'Automatically matches your site styling',
  'forms.embed.script.pro2': 'Responsive and mobile-friendly',
  'forms.embed.script.pro3': 'Updates automatically when form changes',
  'forms.embed.script.pro4': 'Best performance and SEO',
  'forms.embed.script.requirements': 'Requirements',
  'forms.embed.script.req1': 'JavaScript must be enabled',
  'forms.embed.script.req2': 'CORS must allow our domain',
  'forms.embed.script.req3': 'Modern browser required',
  'forms.embed.iframe.title': 'Iframe Embed',
  'forms.embed.iframe.desc': 'Embeds the form in an iframe with fixed dimensions',
  'forms.embed.iframe.preview': 'Preview',
  'forms.embed.iframe.cons': 'Cons',
  'forms.embed.iframe.pro1': 'Works without JavaScript',
  'forms.embed.iframe.pro2': 'Isolated from parent page',
  'forms.embed.iframe.pro3': 'Easy to implement',
  'forms.embed.iframe.con1': 'Fixed height may cause scrolling',
  'forms.embed.iframe.con2': 'Not fully responsive',
  'forms.embed.iframe.con3': 'SEO limitations',
  'forms.embed.custom.title': 'Customized Embed',
  'forms.embed.custom.desc': 'Script embed with additional customization options',
  'forms.embed.custom.code': 'Customized Code',
  'forms.embed.custom.attributes': 'Available Attributes',
  'forms.embed.custom.attr.form': 'Form identifier (required)',
  'forms.embed.custom.attr.org': 'Organization ID (required)',
  'forms.embed.custom.attr.lang': 'Language code (en, it, etc.)',
  'forms.embed.custom.attr.theme': 'Theme (light, dark)',
  'forms.embed.custom.attr.primary': 'Primary color (hex code)',
  'forms.embed.custom.attr.style': 'Custom CSS styles',
  'forms.embed.direct.title': 'Direct Link',
  'forms.embed.direct.desc': 'Direct URL to the form page - perfect for social media and emails',
  'forms.embed.direct.url': 'Direct URL',
  'forms.embed.direct.showQR': 'Show QR Code',
  'forms.embed.direct.hideQR': 'Hide QR Code',
  'forms.embed.direct.useCases': 'Perfect for',
  'forms.embed.direct.case1': 'Social media posts and stories',
  'forms.embed.direct.case2': 'Email campaigns and newsletters',
  'forms.embed.direct.case3': 'QR codes for print materials',
  'forms.embed.direct.case4': 'Quick mobile sharing',
  'forms.embed.tracking.title': 'Conversion Tracking Setup',
  'forms.embed.tracking.description': 'Track form submissions with Meta Pixel, Google Ads, or other analytics platforms.',
  'forms.embed.tracking.step1Title': 'Step 1: Enable Tracking in Form Settings',
  'forms.embed.tracking.step1Description': 'Go to Form Settings -> Conversion Tracking and enable parent notifications.',
  'forms.embed.tracking.step2Title': 'Step 2: Add Listener to Your Page',
  'forms.embed.tracking.step2Description': 'Add this code to the parent page that embeds your form:',
  'forms.embed.tracking.messageFormat': 'Message Format',
  'forms.embed.tracking.proTipsTitle': 'Pro Tips',
  'forms.embed.tracking.tip1': 'Use eventId for deduplication with Conversions API',
  'forms.embed.tracking.tip2': 'Set allowed origins in form settings for security',
  'forms.embed.tracking.tip3': 'Test with browser console to verify messages are sent',
  'forms.embed.tracking.tip4': 'Works with both iframe and script embed methods',
  'forms.submissions.title': 'Form Submissions',
  'forms.submissions.export': 'Export CSV',
  'forms.submissions.search': 'Search submissions...',
  'forms.submissions.allLanguages': 'All Languages',
  'forms.submissions.noSubmissions': 'No submissions found',
  'forms.submissions.noData': 'No submissions to export',
  'forms.submissions.exportSuccess': 'CSV exported successfully',
  'forms.submissions.exportError': 'Failed to export CSV',
  'forms.submissions.consent': 'Consent',
  'forms.submissions.openLead': 'Open Lead',
  'forms.submissions.leadRemoved': 'Lead Removed',
  'forms.submissions.createLead': 'Create Lead',
  'forms.submissions.contactUnavailable': 'Lead contact information no longer available',
  'forms.submissions.contact': 'Contact',
  'forms.submissions.pageUrl': 'Page URL',
  'forms.analytics.title': 'Form Analytics',
  'forms.analytics.range.last7Days': 'Last 7 days',
  'forms.analytics.range.last30Days': 'Last 30 days',
  'forms.analytics.range.last90Days': 'Last 90 days',
  'forms.analytics.exportReport': 'Export Report',
  'forms.analytics.tabs.overview': 'Overview',
  'forms.analytics.tabs.submissions': 'Submissions',
  'forms.analytics.tabs.conversions': 'Conversions',
  'forms.analytics.tabs.fieldAnalysis': 'Field Analysis',
  'forms.analytics.metrics.totalSubmissions': 'Total Submissions',
  'forms.analytics.metrics.inLastDays': 'In last {days} days',
  'forms.analytics.metrics.uniqueVisitors': 'Unique Visitors',
  'forms.analytics.metrics.basedOnIp': 'Based on IP addresses',
  'forms.analytics.metrics.conversionRate': 'Conversion Rate',
  'forms.analytics.metrics.submissionsPerVisitors': 'Submissions / Visitors',
  'forms.analytics.metrics.avgDaily': 'Avg. Daily',
  'forms.analytics.metrics.submissionsPerDay': 'Submissions per day',
  'forms.analytics.noData': 'No analytics data available',
  'forms.properties.dataPreview': 'Data Preview',
  'forms.properties.leadFields': 'Lead Fields',
  'forms.properties.customerFields': 'Customer Fields',
  'forms.properties.customFields': 'Custom Fields',
  'forms.properties.selectDataField': 'Select a data field to map this form field to',
  'forms.properties.noMappingSelected': 'No mapping selected',
  'forms.properties.email': 'Email',
  'forms.properties.firstName': 'First Name',
  'forms.properties.lastName': 'Last Name',
  'forms.properties.phone': 'Phone',
  'forms.properties.budgetMin': 'Budget Min',
  'forms.properties.budgetMax': 'Budget Max',
  'forms.properties.eventDate': 'Event Date',
  'forms.properties.eventLocation': 'Event Location',
  'forms.properties.partnerName': 'Partner Name',
  'forms.properties.source': 'Source',
  'forms.properties.notes': 'Notes',
  'forms.properties.howDidYouHear': 'How Did You Hear',
  'forms.properties.dreamWeddingDescription': 'Dream Wedding Description',
  'forms.properties.specialRequests': 'Special Requests',
  'forms.properties.guestCount': 'Guest Count',
  'forms.properties.ceremony': 'Ceremony',
  'forms.properties.reception': 'Reception',
  'forms.properties.honeymoon': 'Honeymoon',
  'forms.properties.dressSize': 'Dress Size',
  'forms.properties.dressStyle': 'Dress Style',
  'forms.properties.shoeSize': 'Shoe Size',
  'forms.properties.hasChildren': 'Has Children',
  'forms.properties.address': 'Address',
  'forms.properties.city': 'City',
  'forms.properties.country': 'Country',
  'forms.properties.customField1': 'Custom Field 1',
  'forms.properties.customField2': 'Custom Field 2',
  'forms.properties.customField3': 'Custom Field 3',
  'forms.properties.customField4': 'Custom Field 4',
  'forms.properties.customField5': 'Custom Field 5',
  'forms.properties.utmSource': 'UTM Source',
  'forms.properties.utmCampaign': 'UTM Campaign',
  'forms.properties.referrer': 'Referrer',
  'forms.properties.weddingDate': 'Wedding Date',
  'forms.properties.ceremonyVenue': 'Ceremony Venue',
  'forms.properties.receptionVenue': 'Reception Venue',
  'forms.palette.title': 'Form Fields',
  'forms.palette.instruction': 'Drag and drop fields onto the canvas to build your form',
  'forms.palette.fields.text': 'Text Input',
  'forms.palette.descriptions.text': 'Single line text input field',
  'forms.palette.fields.textarea': 'Text Area',
  'forms.palette.descriptions.textarea': 'Multi-line text input field',
  'forms.palette.fields.email': 'Email',
  'forms.palette.descriptions.email': 'Email address input with validation',
  'forms.palette.fields.phone': 'Phone',
  'forms.palette.descriptions.phone': 'Phone number input with formatting',
  'forms.palette.fields.number': 'Number',
  'forms.palette.descriptions.number': 'Numeric input field',
  'forms.palette.fields.date': 'Date',
  'forms.palette.descriptions.date': 'Date picker input',
  'forms.palette.fields.datetime': 'Date & Time',
  'forms.palette.descriptions.datetime': 'Date and time picker input',
  'forms.palette.fields.select': 'Dropdown',
  'forms.palette.descriptions.select': 'Single selection dropdown menu',
  'forms.palette.fields.multiselect': 'Multi-Select',
  'forms.palette.descriptions.multiselect': 'Multiple selection dropdown',
  'forms.palette.fields.checkbox': 'Checkbox',
  'forms.palette.descriptions.checkbox': 'Single checkbox for yes/no options',
  'forms.palette.fields.radio': 'Radio Buttons',
  'forms.palette.descriptions.radio': 'Single choice from multiple options',
  'forms.palette.fields.file': 'File Upload',
  'forms.palette.descriptions.file': 'File upload field',
  'forms.palette.fields.country': 'Country',
  'forms.palette.descriptions.country': 'Country selection dropdown',
  'forms.palette.fields.language': 'Language',
  'forms.palette.descriptions.language': 'Language selection dropdown',
  'forms.palette.fields.consent': 'Consent',
  'forms.palette.descriptions.consent': 'Consent checkbox with custom text',
  'forms.palette.fields.hidden': 'Hidden Field',
  'forms.palette.descriptions.hidden': 'Hidden field for tracking data',
  'forms.canvas.title': 'Form Builder',
  'forms.canvas.instruction': 'Drag fields here to build your form',
  'forms.canvas.instructions': 'Drag fields to reorder them. Click to edit properties.',
  'forms.canvas.emptyState': 'No fields added yet. Choose fields from the palette to get started.',
  'forms.canvas.dragHandle': 'Drag to reorder',
  'forms.canvas.deleteField': 'Delete field',
  'forms.canvas.selectField': 'Click to edit field properties',
  'forms.canvas.noFields': 'No fields added yet',
  'forms.canvas.addFields': 'Add fields from the palette to get started',
  'forms.canvas.selectOption': 'Select an option',
  'forms.canvas.selectCountry': 'Select country',
  'forms.canvas.selectLanguage': 'Select language',
  'forms.canvas.italy': 'Italy',
  'forms.canvas.unitedStates': 'United States',
  'forms.canvas.unitedKingdom': 'United Kingdom',
  'forms.canvas.english': 'English',
  'forms.canvas.italian': 'Italian',
  'forms.canvas.french': 'French',
  'forms.canvas.hiddenField': 'Hidden field:',
  'forms.canvas.uploadText': 'Click to upload or drag and drop',
  'forms.properties.title': 'Field Properties',
  'forms.properties.basicTab': 'Basic',
  'forms.properties.localesTab': 'Locales',
  'forms.properties.mappingTab': 'Mapping',
  'forms.properties.label': 'Label',
  'forms.properties.placeholder': 'Placeholder',
  'forms.properties.required': 'Required',
  'forms.properties.defaultValue': 'Default Value',
  'forms.properties.validation': 'Validation',
  'forms.properties.options': 'Options',
  'forms.properties.addOption': 'Add Option',
  'forms.properties.helpText': 'Help Text',
  'forms.properties.consentText': 'Consent Text',
  'forms.properties.minLength': 'Minimum Length',
  'forms.properties.maxLength': 'Maximum Length',
  'forms.properties.minValue': 'Minimum Value',
  'forms.properties.maxValue': 'Maximum Value',
  'forms.properties.pattern': 'Pattern (Regex)',
  'forms.properties.patternMessage': 'Pattern Error Message',
  'forms.properties.labelLocale': 'Label ({locale})',
  'forms.properties.placeholderLocale': 'Placeholder ({locale})',
  'forms.properties.helpTextLocale': 'Help Text ({locale})',
  'forms.properties.consentTextLocale': 'Consent Text ({locale})',
  'forms.properties.mapToField': 'Map to Field',
  'forms.properties.mappingHelp': 'Connect this field to a customer data field',
  'forms.properties.selectMapping': 'Select field mapping',
  'forms.properties.selectField': 'Select a field to edit its properties',
  'forms.properties.fieldInfo': 'Field information',
  'forms.properties.typeLabel': 'Type:',
  'forms.properties.idLabel': 'ID:',
  'forms.properties.requiredLabel': 'Required:',
  'forms.properties.optionsLabel': 'Options:',
  'forms.properties.itemsCount': 'items',
  'forms.properties.yes': 'Yes',
  'forms.properties.no': 'No',
  'forms.properties.placeholder.fieldLabel': 'Field label',
  'forms.properties.placeholder.placeholderText': 'Placeholder text',
  'forms.properties.optionPlaceholder': 'Option {number}',
  'forms.properties.helpTextPlaceholder': 'Additional help text for this field',
  'forms.properties.fieldPath': 'Field path:',
  'forms.properties.descriptionLabel': 'Description:',
  'forms.properties.descriptionLead': 'Data will be stored in the lead record',
  'forms.properties.descriptionCustomer': 'Data will be stored in the customer profile',
  'forms.properties.descriptionCustom': 'Data will be stored as a custom attribute',
  'forms.properties.entityLead': 'Lead',
  'forms.properties.entityCustomer': 'Customer',
  'forms.properties.entityCustom': 'Custom',
  'forms.properties.leadPrefix': 'Lead ->',
  'forms.properties.customerPrefix': 'Customer ->',
  'forms.properties.customLeadPrefix': 'Custom (Lead) ->',
  'forms.properties.customCustomerPrefix': 'Custom (Customer) ->',
  'forms.properties.customPrefix': 'Custom ->',
  'forms.preview.title': 'Form Preview',
  'forms.preview.empty': 'No fields to preview',
  'forms.preview.emptyDesc': 'Add fields to the form to see a preview',
  'forms.preview.instructions': 'Preview how the form will appear to users',
  'forms.preview.submit': 'Submit Form',
  'forms.preview.reset': 'Reset',
  'forms.preview.submitting': 'Submitting...',
  'forms.preview.success': 'Form submitted successfully!',
  'forms.preview.error': 'Failed to submit form',
  'forms.preview.validation.required': 'This field is required',
  'forms.preview.validation.email': 'Enter a valid email address',
  'forms.preview.validation.minLength': 'Enter at least {min} characters',
  'forms.preview.validation.maxLength': 'Enter at most {max} characters',
  'forms.preview.validation.min': 'Value must be at least {min}',
  'forms.preview.validation.max': 'Value cannot exceed {max}',
  'forms.preview.validation.pattern': 'Invalid format',
  'forms.preview.placeholders.text': 'Enter text...',
  'forms.preview.placeholders.email': 'you@email.com',
  'forms.preview.placeholders.phone': '+1 234 567 8900',
  'forms.preview.placeholders.number': '0',
  'forms.preview.placeholders.textarea': 'Enter your message...',
  'forms.preview.placeholders.select': 'Select an option',
  'forms.preview.country.italy': 'Italy',
  'forms.preview.country.usa': 'United States',
  'forms.preview.country.uk': 'United Kingdom',
  'forms.preview.country.france': 'France',
  'forms.preview.country.germany': 'Germany',
  'forms.preview.country.spain': 'Spain',
  'forms.preview.language.en': 'English',
  'forms.preview.language.it': 'Italian',
  'forms.preview.language.fr': 'French',
  'forms.preview.language.de': 'German',
  'forms.preview.language.es': 'Spanish',
  'forms.preview.consent.text': 'I agree to the terms and conditions',
  'forms.preview.consent.required': 'You must agree to the terms to continue',
  'forms.preview.testMode': 'Test Mode',
  'forms.preview.language': 'Language',
  'forms.preview.submitForm': 'Submit Form',
  'forms.preview.resetForm': 'Reset Form',
  'forms.preview.selectOption': 'Select an option',
  'forms.preview.selectCountry': 'Select country',
  'forms.preview.selectLanguage': 'Select language',
  'forms.preview.noFields': 'No fields to preview',
  'forms.preview.addFieldsToPreview': 'Add fields to preview the form',
  'forms.preview.italy': 'Italy',
  'forms.preview.unitedStates': 'United States',
  'forms.preview.unitedKingdom': 'United Kingdom',
  'forms.preview.france': 'France',
  'forms.preview.germany': 'Germany',
  'forms.preview.spain': 'Spain',
  'forms.preview.english': 'English',
  'forms.preview.italian': 'Italian',
  'forms.preview.french': 'French',
  'forms.preview.german': 'German',
  'forms.preview.spanish': 'Spanish',
  'forms.preview.uploadText': 'Click to upload or drag and drop',
  'forms.preview.maxFileSize': 'Max file size: 10MB',
  'forms.preview.notImplemented': 'field type not yet implemented',
  'forms.settings.title': 'Form Settings',
  'forms.settings.success.title': 'Success Behavior',
  'forms.settings.success.message': 'Success Message',
  'forms.settings.success.redirect': 'Redirect URL',
  'forms.settings.success.placeholders.message': 'Thank you for your submission!',
  'forms.settings.success.placeholders.url': 'https://yoursite.com/thank-you',
  'forms.settings.spam': 'Spam Protection',
  'forms.settings.spam.honeypot': 'Honeypot Protection',
  'forms.settings.spam.honeypotHelp': 'Hidden field to detect spam bots',
  'forms.settings.spam.rateLimit': 'Rate Limit',
  'forms.settings.spam.rateLimitHelp': 'Maximum {count} submissions per IP every {minutes} minutes',
  'forms.settings.spam.recaptcha': 'reCAPTCHA v3',
  'forms.settings.spam.recaptchaHelp': 'Invisible Google reCAPTCHA protection',
  'forms.settings.notifications': 'Notifications',
  'forms.settings.notifications.email': 'Email Notifications',
  'forms.settings.notifications.emailHelp': 'Send email when form is submitted',
  'forms.settings.notifications.recipients': 'Email Recipients',
  'forms.settings.notifications.addRecipient': 'Add Recipient',
  'forms.settings.notifications.subject': 'Email Subject',
  'forms.settings.notifications.subjectPlaceholder': 'New form submission from {formName}',
  'forms.settings.notifications.inApp': 'In-App Notifications',
  'forms.settings.notifications.inAppHelp': 'Show notifications in dashboard',
  'forms.settings.notifications.webhook': 'Webhook Integration',
  'forms.settings.notifications.webhookHelp': 'Send form data to a custom endpoint',
  'forms.settings.notifications.webhookUrl': 'Webhook URL',
  'forms.settings.notifications.webhookSecret': 'Webhook Secret Key',
  'forms.settings.successBehavior': 'Success Behavior',
  'forms.settings.spamProtection': 'Spam Protection',
  'forms.settings.behaviorType': 'Behavior Type',
  'forms.settings.showMessage': 'Show Message',
  'forms.settings.redirectToUrl': 'Redirect to URL',
  'forms.settings.successMessageLocale': 'Success Message ({locale})',
  'forms.settings.redirectUrlLocale': 'Redirect URL ({locale})',
  'forms.settings.english': 'English',
  'forms.settings.italian': 'Italian',
  'forms.settings.enableHoneypot': 'Enable Honeypot Protection',
  'forms.settings.honeypotDesc': 'Hidden field to catch bots',
  'forms.settings.honeypotFieldName': 'Honeypot Field Name',
  'forms.settings.rateLimit': 'Rate Limit (submissions per IP per hour)',
  'forms.settings.recaptcha': 'reCAPTCHA v3',
  'forms.settings.recaptchaDesc': 'Requires site key configuration',
  'forms.settings.minScore': 'Minimum Score (0.0 - 1.0)',
  'forms.settings.emailNotifications': 'Email Notifications',
  'forms.settings.emailDesc': 'Send email alerts when forms are submitted',
  'forms.settings.emailRecipients': 'Email Recipients',
  'forms.settings.emailSubject': 'Email Subject Template',
  'forms.settings.placeholders.email': 'email@example.com',
  'forms.settings.inAppNotifications': 'In-App Notifications',
  'forms.settings.inAppDesc': 'Show notifications in the app',
  'forms.settings.webhookIntegration': 'Webhook Integration',
  'forms.settings.webhookDesc': 'Send HTTP POST requests on form submission',
  'forms.settings.webhookUrl': 'Webhook URL',
  'forms.settings.secretKey': 'Secret Key (optional)',
  'forms.settings.secretKeyDesc': 'Used for HMAC signature verification',
  'forms.settings.hmacHelp': 'Used to generate the HMAC-SHA256 signature for data integrity verification',
  'forms.settings.tracking.title': 'Conversion Tracking',
  'forms.settings.tracking.description': 'Enable tracking for Meta Pixel, Google Ads, and other analytics platforms when forms are embedded in iframes.',
  'forms.settings.tracking.enableParentNotifications': 'Enable Parent Notifications',
  'forms.settings.tracking.parentNotificationsHelp': 'Send postMessage to parent window when form is submitted',
  'forms.settings.tracking.trackLeadValue': 'Track Lead Value',
  'forms.settings.tracking.trackLeadValueHelp': 'Include lead value in tracking payload',
  'forms.settings.tracking.defaultLeadValue': 'Default Lead Value',
  'forms.settings.tracking.defaultLeadValueHelp': 'Value to assign to each form submission for ROI tracking',
  'forms.settings.tracking.allowedParentOrigins': 'Allowed Parent Origins (Optional)',
  'forms.settings.tracking.allowedParentOriginsHelp': 'One origin per line. Leave empty to allow all origins (*). For security, specify your domain.',
  'forms.settings.tracking.messageFormat': 'Message Format',
  'forms.validation.required': 'is required',
  'forms.validation.invalidEmail': 'Enter a valid email address',
  'forms.validation.invalidPhone': 'Enter a valid phone number',
  'forms.validation.invalidNumber': 'Enter a valid number',
  'forms.validation.minValue': 'Must be at least',
  'forms.validation.maxValue': 'Must be at most',
  'forms.validation.minLength': 'Must be at least',
  'forms.validation.maxLength': 'Must be at most',
  'forms.validation.characters': 'characters',
  'forms.validation.invalidFormat': 'Invalid format',
  'forms.toast.fixErrors': 'Fix the errors below',
  'forms.toast.thankYou': 'Thank you for your submission!',
  'forms.toast.submitted': 'Form submitted successfully!',
  'forms.toast.errorSubmitting': 'There was an error submitting the form',
  'forms.toast.submissionFailed': 'Submission failed. Please try again.',
};
